/* MARMOT OpenAI Ads — чиста логика за пиксела (без DOM, без мрежа).

   Изнесена отделно за `node --test`. В браузъра се закача на
   window.MarmotOpenAiAdsLogic, а в Node се експортва през module.exports.
   Обвивката с DOM, съгласието и мрежата е в marmot-openai-ads.js. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.MarmotOpenAiAdsLogic = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var CURRENCY = 'EUR';
  var PENDING_ADD_MAX_AGE_MS = 60000;

  /* Евро → цели евроцентове. 24.90 → 2490; 0.1 + 0.2 → 30, не 30.000000000000004.
     Приема и низ с десетична запетая („24,90"). Непознато → 0.
     Резерва за вход в евро (брифът я иска тествана); днешните входове –
     cart.js и ShopifyAnalytics.meta – вече са в центове и минават през cents(). */
  function eurosToCents(value) {
    var n = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : Number(value);
    if (!isFinite(n)) return 0;
    return Math.round(n * 100);
  }

  /* Стойност, която вече е в центове (cart.js, ShopifyAnalytics.meta). */
  function cents(value) {
    var n = Number(value);
    return isFinite(n) ? Math.round(n) : 0;
  }

  function wholeQuantity(value) {
    var n = Math.round(Number(value));
    return isFinite(n) && n > 0 ? n : 0;
  }

  /* Общият payload за събитията от вид `contents`. Редовете са
     { id, name, quantity, unitCents, lineCents? }. Сумата на събитието е сборът
     на редовете (lineCents, ако е подаден – при отстъпка cart.js вече го е
     сметнал; иначе количество × единична цена). Артикулът носи ЕДИНИЧНАТА цена
     в `amount`, както Meta носи item_price. Празно → null: обвивката не праща. */
  function contentsPayload(lines) {
    var rows = Array.isArray(lines) ? lines.filter(function (line) {
      return line && line.id && wholeQuantity(line.quantity) > 0;
    }) : [];
    if (!rows.length) return null;

    var amount = 0;
    var contents = rows.map(function (line) {
      var quantity = wholeQuantity(line.quantity);
      var unit = cents(line.unitCents);
      var lineTotal = line.lineCents == null ? unit * quantity : cents(line.lineCents);
      amount += lineTotal;
      return {
        id: String(line.id),
        name: String(line.name || ''),
        content_type: 'product',
        quantity: quantity,
        amount: unit,
        currency: CURRENCY
      };
    });
    return { type: 'contents', amount: amount, currency: CURRENCY, contents: contents };
  }

  /* ---- contents_viewed: продуктова страница ---- */

  function isProductPage(meta) {
    if (!meta || !meta.product || !Array.isArray(meta.product.variants) || !meta.product.variants.length) return false;
    if (meta.page && meta.page.pageType && meta.page.pageType !== 'product') return false;
    return true;
  }

  /* Кой вариант гледа човекът: избраният от Shopify, после ?variant= от адреса,
     после стойността във формата, накрая първият. Непознато id пада надолу. */
  function selectedVariant(meta, hints) {
    if (!isProductPage(meta)) return null;
    var variants = meta.product.variants;
    var candidates = [hints && hints.selectedVariantId, hints && hints.urlVariantId, hints && hints.formVariantId];
    for (var i = 0; i < candidates.length; i++) {
      var wanted = candidates[i] == null ? '' : String(candidates[i]);
      if (!wanted) continue;
      for (var j = 0; j < variants.length; j++) {
        if (String(variants[j].id) === wanted) return variants[j];
      }
    }
    return variants[0];
  }

  function contentsViewedPayload(meta, hints) {
    var variant = selectedVariant(meta, hints);
    if (!variant || variant.id == null) return null;
    return contentsPayload([{
      id: variant.id,
      name: variant.name || (meta.product && meta.product.handle) || '',
      quantity: 1,
      unitCents: variant.price
    }]);
  }

  /* ---- items_added: отговорът на /cart/add.js ---- */

  function pathOf(url) {
    var text = typeof url === 'string' ? url : '';
    return text.split(/[?#]/)[0];
  }

  function isCartAddUrl(url) {
    return /(^|\/)cart\/add(\.js)?$/.test(pathOf(url));
  }

  /* Промяна на количество: /cart/change (Lumia „+"/„−" в количката). */
  function isCartChangeUrl(url) {
    return /(^|\/)cart\/change(\.js)?$/.test(pathOf(url));
  }

  /* Заявки, чийто отговор е ЦЯЛАТА количка: /cart.js, /cart/update.js. */
  function isCartStateUrl(url) {
    return /(^|\/)cart(\.js)?$/.test(pathOf(url)) || /(^|\/)cart\/update(\.js)?$/.test(pathOf(url));
  }

  /* Тялото на заявка като обикновен обект: JSON низ, urlencoded низ,
     FormData/URLSearchParams (през get) или вече обект. Непознато → null. */
  function requestBodyObject(body) {
    if (body == null) return null;
    if (typeof body === 'string') {
      var text = body.trim();
      if (!text) return null;
      if (text.charAt(0) === '{') { try { return JSON.parse(text); } catch (e) { return null; } }
      var out = {};
      var pairs = text.split('&');
      for (var i = 0; i < pairs.length; i++) {
        var eq = pairs[i].indexOf('=');
        if (eq === -1) continue;
        try { out[decodeURIComponent(pairs[i].slice(0, eq))] = decodeURIComponent(pairs[i].slice(eq + 1).replace(/\+/g, ' ')); } catch (e) { /* пропуска счупена двойка */ }
      }
      return out;
    }
    if (typeof body.get === 'function') {
      var picked = {};
      var keys = ['id', 'quantity', 'line', 'updates'];
      for (var k = 0; k < keys.length; k++) {
        var v = body.get(keys[k]);
        if (v != null && typeof v !== 'object') picked[keys[k]] = v;
      }
      return picked;
    }
    return typeof body === 'object' ? body : null;
  }

  /* Каква е заявката за количката: 'add' (нови бройки), 'change' (ново
     количество на ред: /cart/change или /cart/update с `updates`), 'state'
     (само четене/атрибути – отговорът опреснява снимката), null – не е за нас. */
  function cartRequestKind(url, method, body) {
    var verb = String(method || 'GET').toUpperCase();
    if (isCartAddUrl(url)) return verb === 'POST' ? 'add' : null;
    if (isCartChangeUrl(url)) return verb === 'POST' ? 'change' : null;
    if (!isCartStateUrl(url)) return null;
    if (verb === 'POST' && /(^|\/)cart\/update(\.js)?$/.test(pathOf(url))) {
      var parsed = requestBodyObject(body);
      if (parsed && parsed.updates != null) return 'change';
    }
    return 'state';
  }

  /* Заявените бройки от тялото на POST /cart/add(.js): { variantId: quantity }.
     Нужно е, защото отговорът на Shopify носи ОБЩОТО количество на реда (при
     втори път същата книга връща 2, а е добавена 1 – проверено на живо, 21.09).
     Без разбираемо тяло → null. */
  function addRequestQuantities(body) {
    var parsed = requestBodyObject(body);
    if (!parsed) return null;
    var out = {};
    var any = false;
    var items = Array.isArray(parsed.items) ? parsed.items : (parsed.id != null ? [parsed] : []);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item || item.id == null) continue;
      var id = String(item.id).trim();
      if (!/^\d+$/.test(id)) continue;
      var quantity = wholeQuantity(item.quantity == null || item.quantity === '' ? 1 : item.quantity);
      if (!quantity) continue;
      out[id] = (out[id] || 0) + quantity;
      any = true;
    }
    return any ? out : null;
  }

  function cartLine(item) {
    if (!item || typeof item !== 'object') return null;
    var id = item.variant_id != null ? item.variant_id : item.id;
    if (id == null) return null;
    var unit = item.final_price != null ? item.final_price : item.price;
    return {
      id: id,
      key: item.key != null ? String(item.key) : String(id),
      name: item.title || item.product_title || '',
      quantity: item.quantity,
      unitCents: unit,
      lineCents: item.final_line_price != null ? item.final_line_price : undefined
    };
  }

  /* /cart/add.js връща или един ред (form data), или { items: [...] } (JSON).
     Грешката носи числово `status` (422) и описание – тя не е добавяне. */
  function addResponseLines(json) {
    if (!json || typeof json !== 'object') return [];
    if (typeof json.status === 'number') return [];
    var source = Array.isArray(json.items) ? json.items : [json];
    return source.map(cartLine).filter(Boolean);
  }

  /* Бройките са ЗАЯВЕНИТЕ (requested = addRequestQuantities), не тези от
     отговора; сумата е бройки × единична цена. Без разбираемо тяло се пада
     на отговора – верен само за ред, който не е бил в количката. */
  function itemsAddedPayload(json, requested) {
    var lines = addResponseLines(json).map(function (line) {
      var quantity = line.quantity;
      if (requested && typeof requested === 'object') {
        var wanted = requested[String(line.id)];
        if (!wanted) return null;
        quantity = Math.min(wholeQuantity(wanted), wholeQuantity(line.quantity) || wholeQuantity(wanted));
      }
      return { id: line.id, name: line.name, quantity: quantity, unitCents: line.unitCents };
    }).filter(Boolean);
    return contentsPayload(lines);
  }

  /* Успех е само 2xx HTTP без грешка в тялото. */
  function addSucceeded(httpStatus, json) {
    var status = Number(httpStatus);
    if (!(status >= 200 && status < 300)) return false;
    return addResponseLines(json).length > 0;
  }

  /* ---- items_added при „+" в количката: /cart/change ----
     Отговорът е цялата количка; „добавени бройки" са само положителните разлики
     спрямо последната ИЗВЕСТНА снимка на реда (по key на реда). Непознат ред
     или липсваща снимка → нищо (по-добре пропуск, отколкото измислен брой). */
  function isFullCart(json) {
    return !!json && typeof json === 'object' && Array.isArray(json.items) && typeof json.item_count === 'number';
  }

  function cartSnapshot(cart) {
    if (!isFullCart(cart)) return null;
    var snap = {};
    for (var i = 0; i < cart.items.length; i++) {
      var line = cartLine(cart.items[i]);
      if (line) snap[line.key] = wholeQuantity(line.quantity);
    }
    return snap;
  }

  /* Отговорът на /cart/add.js носи общото количество на реда – точно каквото
     трябва в снимката. Липсва ли снимка, тръгва частична: само тези редове. */
  function snapshotWithAdded(snapshot, addJson) {
    var lines = addResponseLines(addJson);
    if (!lines.length) return snapshot;
    var next = {};
    if (snapshot && typeof snapshot === 'object') for (var k in snapshot) next[k] = snapshot[k];
    for (var i = 0; i < lines.length; i++) next[lines[i].key] = wholeQuantity(lines[i].quantity);
    return next;
  }

  function quantityDeltaLines(snapshot, nextCart) {
    if (!snapshot || typeof snapshot !== 'object' || !isFullCart(nextCart)) return [];
    var out = [];
    for (var i = 0; i < nextCart.items.length; i++) {
      var line = cartLine(nextCart.items[i]);
      if (!line || !Object.prototype.hasOwnProperty.call(snapshot, line.key)) continue;
      var delta = wholeQuantity(line.quantity) - wholeQuantity(snapshot[line.key]);
      if (delta > 0) out.push({ id: line.id, name: line.name, quantity: delta, unitCents: line.unitCents });
    }
    return out;
  }

  function changeSucceeded(httpStatus, json) {
    var status = Number(httpStatus);
    return status >= 200 && status < 300 && isFullCart(json) && !json.errors;
  }

  /* ---- items_added през родната форма на продуктовата страница ----
     Формата праща POST /cart/add и напуска страницата, затова маркерът минава
     през sessionStorage: пише се при submit, чете се на следващата страница. */
  function pendingAddMarker(fields, now) {
    var id = fields && fields.id != null ? String(fields.id).trim() : '';
    if (!/^\d+$/.test(id)) return null;
    var quantity = wholeQuantity(fields.quantity == null || fields.quantity === '' ? 1 : fields.quantity);
    if (!quantity) return null;
    var returnTo = fields.return_to != null ? String(fields.return_to).trim() : '';
    return { id: id, quantity: quantity, at: Number(now) || 0, returnTo: returnTo };
  }

  function normalizePath(path) {
    var text = String(path == null ? '' : path).split(/[?#]/)[0].replace(/\/+$/, '');
    if (!text) return '/';
    return text.charAt(0) === '/' ? text : '/' + text;
  }

  /* Кацна ли се там, където успешното добавяне води? Shopify при успех праща
     към return_to (без него – към /cart), а при грешка (няма наличност) връща
     обратно на продуктовата страница. Маркер, консумиран другаде, е провал или
     навигация настрани – без събитие. `return_to=back` не се разпознава (води
     пак към продуктовата страница) и се брои за /cart – по-добре пропуск. */
  function pendingAddLanded(marker, pathname) {
    if (!marker || typeof marker !== 'object') return false;
    var wanted = marker.returnTo && String(marker.returnTo).charAt(0) === '/' ? normalizePath(marker.returnTo) : '/cart';
    var actual = normalizePath(pathname);
    // Локален префикс (/bg/cart) също минава – wanted започва с „/", тоест границата е сигурна.
    return actual === wanted || (actual.length > wanted.length && actual.slice(-wanted.length) === wanted);
  }

  function pendingAddIsFresh(marker, now, maxAgeMs) {
    if (!marker || typeof marker !== 'object' || !/^\d+$/.test(String(marker.id || ''))) return false;
    var age = (Number(now) || 0) - (Number(marker.at) || 0);
    var limit = maxAgeMs == null ? PENDING_ADD_MAX_AGE_MS : maxAgeMs;
    return age >= 0 && age <= limit;
  }

  /* Редът на добавения вариант от /cart.js. Количеството е заявеното, но не
     повече от наличното в количката; липсва ли вариантът, добавянето не е минало. */
  function pendingAddLines(marker, cart, now, maxAgeMs) {
    if (!pendingAddIsFresh(marker, now, maxAgeMs)) return [];
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    for (var i = 0; i < items.length; i++) {
      var line = cartLine(items[i]);
      if (!line || String(line.id) !== String(marker.id)) continue;
      var have = wholeQuantity(line.quantity);
      if (!have) return [];
      var quantity = Math.min(wholeQuantity(marker.quantity) || 1, have);
      return [{ id: line.id, name: line.name, quantity: quantity, unitCents: line.unitCents }];
    }
    return [];
  }

  /* ---- checkout_started: /cart.js ---- */

  function cartLines(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.map(cartLine).filter(Boolean);
  }

  function checkoutStartedPayload(cart) {
    return contentsPayload(cartLines(cart));
  }

  /* ---- Съгласие и бисквитки ---- */

  function readCookie(cookieString, name) {
    var text = typeof cookieString === 'string' ? cookieString : '';
    var parts = text.split(';');
    for (var i = 0; i < parts.length; i++) {
      var pair = parts[i].trim();
      var eq = pair.indexOf('=');
      if (eq === -1) continue;
      if (pair.slice(0, eq) !== name) continue;
      try { return decodeURIComponent(pair.slice(eq + 1)); } catch (e) { return pair.slice(eq + 1); }
    }
    return '';
  }

  /* Низовете за изтриване на бисквитка, без да знаем на кой домейн я е сложил
     SDK-то: без домейн, самият хост и всеки родител с поне два етикета, с и без
     водеща точка. */
  function cookieExpireStrings(name, host) {
    var suffix = '=; Max-Age=0; Path=/';
    var out = [name + suffix];
    var labels = typeof host === 'string' && host ? host.split('.') : [];
    if (/^\d+\.\d+\.\d+\.\d+$/.test(host) || labels.length < 2) return out;
    for (var i = 0; i <= labels.length - 2; i++) {
      var domain = labels.slice(i).join('.');
      out.push(name + suffix + '; Domain=' + domain);
      out.push(name + suffix + '; Domain=.' + domain);
    }
    return out;
  }

  /* visitorConsentCollected носи detail.marketingAllowed; липсва ли – null, и
     обвивката пита Shopify.customerPrivacy.marketingAllowed() наново. */
  function consentFromEvent(detail) {
    if (detail && typeof detail.marketingAllowed === 'boolean') return detail.marketingAllowed;
    return null;
  }

  /* Shopify държи marketingAllowed() false и преди човекът да е избрал.
     Изричният отказ се различава по currentVisitorConsent().marketing === 'no'. */
  function consentState(marketingAllowed, currentConsent) {
    var marketing = currentConsent && currentConsent.marketing;
    if (marketing === 'no') return 'denied';
    if (marketingAllowed === true || marketing === 'yes') return 'granted';
    return 'pending';
  }

  function limitedOppref(value) {
    var text = value == null ? '' : String(value);
    return text ? text.slice(0, 1024) : '';
  }

  /* Пази клика единствено в адреса. pageUrl е текущият адрес и служи, за да
     не превръщаме навигация само до котва в ново зареждане. */
  function decorateHref(href, pageOrigin, oppref, pageUrl) {
    var raw = typeof href === 'string' ? href.trim() : '';
    var value = limitedOppref(oppref);
    if (!raw || !value || raw.charAt(0) === '#') return null;
    var base;
    var url;
    try {
      base = new URL(pageUrl || pageOrigin);
      url = new URL(raw, base.href);
    } catch (e) { return null; }
    if (!/^https?:$/.test(url.protocol) || url.origin !== base.origin) return null;
    if (url.searchParams.has('oppref')) return null;
    var path = url.pathname;
    if (/(^|\/)checkouts?(?:\/|$)/.test(path) || /(^|\/)account(?:\/|$)/.test(path)) return null;
    if (/\/cart\/(?:add|change|update)(?:\.js)?(?:\/|$)/.test(path) || /\/cart\/[^/]+\.js$/.test(path)) return null;
    // Постоянна връзка за количка (/cart/123:1) води направо към checkout.
    if (/\/cart\/\d+:\d+/.test(path)) return null;
    if (url.hash && url.pathname === base.pathname) {
      // Котва в същата страница (заявката без oppref е същата) не е ново зареждане.
      var baseQuery = new URLSearchParams(base.search);
      baseQuery.delete('oppref');
      if (url.searchParams.toString() === baseQuery.toString()) return null;
    }
    url.searchParams.append('oppref', value);
    return url.href;
  }

  function opprefFromUrl(href) {
    try { return limitedOppref(new URL(href).searchParams.get('oppref')); } catch (e) { return ''; }
  }

  function linkTargetAllowsDecoration(target, hasDownload) {
    if (hasDownload) return false;
    var name = target == null ? '' : String(target).trim().toLowerCase();
    return !name || name === '_self' || name === '_blank';
  }

  function urlWithoutOppref(href) {
    try {
      var url = new URL(href);
      if (!url.searchParams.has('oppref')) return null;
      url.searchParams.delete('oppref');
      return url.pathname + url.search + url.hash;
    } catch (e) { return null; }
  }

  /* Ключовете в sessionStorage, които SDK-то пише (oaiq_cs:<pixel> и др.). */
  function pixelSessionKeys(keys) {
    var out = [];
    if (!keys || typeof keys.length !== 'number') return out;
    for (var i = 0; i < keys.length; i++) {
      if (typeof keys[i] === 'string' && keys[i].indexOf('oaiq_') === 0) out.push(keys[i]);
    }
    return out;
  }

  function debugRequested(search) {
    return /(^|[?&])oai_debug=1(&|$)/.test(typeof search === 'string' ? search : '');
  }

  /* ---- _oppref в количката ----
     value е '' без съгласие или без бисквитка: тогава атрибутът се маха
     (празен низ в /cart/update.js трие атрибута). */
  function cartAttributeValue(cart, key) {
    var attrs = cart && cart.attributes;
    if (!attrs) return '';
    if (Array.isArray(attrs)) {
      for (var i = 0; i < attrs.length; i++) {
        if (attrs[i] && (attrs[i].key === key || attrs[i].name === key)) return String(attrs[i].value || '');
      }
      return '';
    }
    return attrs[key] == null ? '' : String(attrs[key]);
  }

  function currentOppref(cart) {
    return cartAttributeValue(cart, '_oppref');
  }

  function opprefSyncPlan(cart, value) {
    var wanted = limitedOppref(value);
    return { update: currentOppref(cart) !== wanted, value: wanted };
  }

  function pixelAttributesPlan(cart, values) {
    values = values || {};
    var attributes = {
      _oppref: limitedOppref(values.oppref),
      _obref: limitedOppref(values.obref)
    };
    return {
      update: cartAttributeValue(cart, '_oppref') !== attributes._oppref ||
        cartAttributeValue(cart, '_obref') !== attributes._obref,
      attributes: attributes
    };
  }

  /* Резерва при успешен, но не-JSON отговор на /cart/update.js. Shopify маха
     атрибутите с празна стойност; останалите атрибути на количката се пазят. */
  function cartAttributesAfterPlan(cart, planAttributes) {
    var out = {};
    var attrs = cart && cart.attributes;
    if (Array.isArray(attrs)) {
      for (var i = 0; i < attrs.length; i++) {
        var row = attrs[i];
        var key = row && (row.key || row.name);
        if (key && row.value != null && row.value !== '') out[key] = String(row.value);
      }
    } else if (attrs && typeof attrs === 'object') {
      for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k) && attrs[k] != null && attrs[k] !== '') out[k] = String(attrs[k]);
    }
    planAttributes = planAttributes || {};
    for (var name in planAttributes) {
      if (!Object.prototype.hasOwnProperty.call(planAttributes, name)) continue;
      if (planAttributes[name]) out[name] = String(planAttributes[name]);
      else delete out[name];
    }
    return out;
  }

  /* ---- Опашката на стъба преди вмъкване на SDK-то ----
     Стъбът носи consent=false преди init. Щом SDK-то се вмъква (има съгласие),
     тази команда трябва да изчезне от опашката: при преиграването ѝ SDK-то
     (v0.1.41, `consent(false)` → изтрива __oppref и __obref) би зачистило
     кликa от ChatGPT и би завъртяло __obref на ВСЯКА следваща страница –
     видяно на живо на 21.09.2026. Връща нов масив; init и consent=true остават
     в същия ред. */
  function queueWithoutDeniedConsent(queue) {
    var out = [];
    if (!queue || typeof queue.length !== 'number') return out;
    for (var i = 0; i < queue.length; i++) {
      var args = queue[i];
      if (args && args[0] === 'consent' && args[1] === false) continue;
      out.push(args);
    }
    return out;
  }

  return {
    CURRENCY: CURRENCY,
    PENDING_ADD_MAX_AGE_MS: PENDING_ADD_MAX_AGE_MS,
    eurosToCents: eurosToCents,
    cents: cents,
    contentsPayload: contentsPayload,
    isProductPage: isProductPage,
    selectedVariant: selectedVariant,
    contentsViewedPayload: contentsViewedPayload,
    isCartAddUrl: isCartAddUrl,
    isCartChangeUrl: isCartChangeUrl,
    isCartStateUrl: isCartStateUrl,
    requestBodyObject: requestBodyObject,
    cartRequestKind: cartRequestKind,
    addRequestQuantities: addRequestQuantities,
    addResponseLines: addResponseLines,
    itemsAddedPayload: itemsAddedPayload,
    addSucceeded: addSucceeded,
    isFullCart: isFullCart,
    cartSnapshot: cartSnapshot,
    snapshotWithAdded: snapshotWithAdded,
    quantityDeltaLines: quantityDeltaLines,
    changeSucceeded: changeSucceeded,
    pendingAddMarker: pendingAddMarker,
    pendingAddLanded: pendingAddLanded,
    pendingAddIsFresh: pendingAddIsFresh,
    pendingAddLines: pendingAddLines,
    cartLines: cartLines,
    checkoutStartedPayload: checkoutStartedPayload,
    readCookie: readCookie,
    cookieExpireStrings: cookieExpireStrings,
    consentFromEvent: consentFromEvent,
    consentState: consentState,
    decorateHref: decorateHref,
    opprefFromUrl: opprefFromUrl,
    linkTargetAllowsDecoration: linkTargetAllowsDecoration,
    urlWithoutOppref: urlWithoutOppref,
    pixelSessionKeys: pixelSessionKeys,
    debugRequested: debugRequested,
    cartAttributeValue: cartAttributeValue,
    currentOppref: currentOppref,
    opprefSyncPlan: opprefSyncPlan,
    pixelAttributesPlan: pixelAttributesPlan,
    cartAttributesAfterPlan: cartAttributesAfterPlan,
    queueWithoutDeniedConsent: queueWithoutDeniedConsent
  };
});
